var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-icon-button',{attrs:{"label":_vm.loading ? 'Refreshing…' : 'Refresh',"tooltip-placement":"left","disabled":_vm.disabled || _vm.loading,"aria-busy":_vm.loading ? 'true' : 'false'},on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('i',{staticClass:"pi pi-refresh",attrs:{"aria-hidden":"true"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }